import { render, staticRenderFns } from "./VideoTab.vue?vue&type=template&id=26819fb4&scoped=true"
import script from "./VideoTab.vue?vue&type=script&lang=js"
export * from "./VideoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26819fb4",
  null
  
)

export default component.exports